import React from 'react';
import { useTranslation } from 'react-i18next';
import { UserCheck, Timer, Clock, AlertTriangle } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Progress } from '../ui/progress';

const AdvancedReportsStatsCards = ({ analytics }) => {
  const { t } = useTranslation();
  return (
  <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
    <Card>
      <CardContent className="p-6">
        <div className="flex items-center space-x-2">
          <UserCheck className="h-4 w-4 text-blue-600" />
          <div>
            <p className="text-xs font-medium text-muted-foreground">{t('reportsComp.presenceRate')}</p>
            <p className="text-2xl font-bold text-blue-600">{analytics.presence_rate}%</p>
            <div className="mt-2">
              <Progress value={analytics.presence_rate} className="h-1" />
              <p className="text-xs text-muted-foreground mt-1">{t('reportsComp.last30days')}</p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>

    <Card>
      <CardContent className="p-6">
        <div className="flex items-center space-x-2">
          <Timer className="h-4 w-4 text-orange-600" />
          <div>
            <p className="text-xs font-medium text-muted-foreground">{t('reportsComp.lateRate')}</p>
            <p className="text-2xl font-bold text-orange-600">{analytics.retard_rate}%</p>
            <div className="mt-2">
              <Progress value={analytics.retard_rate} className="h-1" />
              <p className="text-xs text-muted-foreground mt-1">{t('reportsComp.thisMonth')}</p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>

    <Card>
      <CardContent className="p-6">
        <div className="flex items-center space-x-2">
          <Clock className="h-4 w-4 text-green-600" />
          <div>
            <p className="text-xs font-medium text-muted-foreground">{t('reportsComp.avgOvertime')}</p>
            <p className="text-2xl font-bold text-green-600">{analytics.heures_sup_moyennes}h</p>
            <p className="text-xs text-muted-foreground mt-2">{t('reportsComp.perEmpWeek')}</p>
          </div>
        </div>
      </CardContent>
    </Card>

    <Card>
      <CardContent className="p-6">
        <div className="flex items-center space-x-2">
          <AlertTriangle className="h-4 w-4 text-red-600" />
          <div>
            <p className="text-xs font-medium text-muted-foreground">{t('reportsComp.anomalyRate')}</p>
            <p className="text-2xl font-bold text-red-600">{analytics.anomalies_rate}%</p>
            <div className="mt-2">
              <Progress value={analytics.anomalies_rate} className="h-1" />
              <p className="text-xs text-muted-foreground mt-1">{t('reportsComp.toProcess')}</p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  </div>
  );
};

export default AdvancedReportsStatsCards;
